import React from 'react'
import _, { concat, round, uniq } from 'lodash'
import moment from 'moment'
import styled from 'styled-components'
import {
  VictoryChart,
  VictoryAxis,
  VictoryArea,
  VictoryScatter,
  VictoryLine,
  VictoryTooltip,
  VictoryVoronoiContainer,
  VictoryLabel
} from 'victory'
import { ConvertWeightSource } from '../../../components/client/comp/weightChart'
import { calcTextWidth } from '../../../utils/String+Extension'
import { BiomeWeightHoverContainer } from '../index.style'
import { ArrowDownOutlined, ArrowUpOutlined } from '@ant-design/icons'

import healthkitIcon from '../../../asserts/icon/device/icon_source_hk.png'
import garminIcon from '../../../asserts/icon/device/icon_source_garmin.png'
import ouraIcon from '../../../asserts/icon/device/icon_source_oura.png'
import PolarIcon from '../../../asserts/icon/device/icon_source_polar.png'
import WithingsIcon from '../../../asserts/icon/device/icon_source_withings.png'
import ApeironScaleIcon from '../../../asserts/icon/ic-biome-weight-apeiron-scale.svg'

export function BiomeWeightChart({ weight, from, width }) {
  const { yTickValues, step, data } = calculatePoints(weight)

  let xAxisTicks = data.map((e) => e.x)
  let xAxisTickCount = from ? weight.length : 7
  if (xAxisTicks.length < xAxisTickCount) {
    xAxisTicks = concat(
      xAxisTicks,
      new Array(xAxisTickCount - xAxisTicks.length)
        .fill(0)
        .map((_, index) => `${index}`)
    )
  }
  if (data.length === 0) {
    return (
      <VictoryChart
        width={width}
        height={220}
        padding={{ top: 18, bottom: 20, left: 30, right: 20 }}
      >
        <VictoryAxis
          tickValues={xAxisTicks}
          style={{
            axis: { stroke: 'rgba(0, 0, 0, 0.1)', strokeDasharray: '3, 3' },
            tickLabels: { fontSize: 10, padding: 5, fill: '#70808E' }
          }}
        />
        <VictoryAxis
          dependentAxis
          offsetX={505}
          tickValues={[0, step, 2 * step, 3 * step]}
          tickFormat={(t) => {
            return t + yTickValues[0]
          }}
          style={{
            axis: { stroke: 'rgba(0, 0, 0, 0.1)', strokeDasharray: '5, 5' },
            grid: {
              stroke: 'rgba(0, 0, 0, 0.1)',
              strokeDasharray: '3, 3'
            },
            tickLabels: { fontSize: 10, padding: 5, fill: '#70808E' }
          }}
        />
      </VictoryChart>
    )
  } else {
    return (
      <>
        <VictoryChart
          width={width}
          height={220}
          padding={{ top: 18, bottom: 20, left: 60, right: 20 }}
          containerComponent={<VictoryVoronoiContainer />}
        >
          <VictoryAxis
            tickValues={xAxisTicks}
            tickFormat={(t) => ' '}
            style={{
              axis: { stroke: 'rgba(0, 0, 0, 0.1)', strokeDasharray: '3, 3' },
              grid: {
                stroke: (tick) => {
                  return tick.length > 0 ? 'rgba(0, 0, 0, 0.1)' : 'transparent'
                },
                strokeDasharray: '3, 3'
              },
              tickLabels: {
                fontSize: 8,
                padding: 5,
                fill: '#97A0A7',
                fontFamily: 'Gliroy'
              }
            }}
          />

          <VictoryAxis
            dependentAxis
            tickValues={[0, step, 2 * step, 3 * step]}
            tickFormat={(t) => {
              return t + yTickValues[0] + ' lbs'
            }}
            style={{
              axis: { stroke: 'rgba(0, 0, 0, 0.1)', strokeDasharray: '3, 3' },
              grid: {
                stroke: 'rgba(0, 0, 0, 0.1)',
                strokeDasharray: '3, 3'
              },
              tickLabels: {
                fontSize: 10,
                padding: 5,
                fill: '#97A0A7',
                fontFamily: 'Gliroy'
              }
            }}
          />
          <VictoryArea style={{ data: { fill: 'url(#linear)' } }} data={data} />
          <VictoryLine
            data={data}
            labels={(datum) => {
              return datum.text
            }}
            labelComponent={
              <VictoryLabel
                renderInPortal={true}
                dy={(datum) => {
                  const index = data.findIndex(({ x }) => x === datum.x)
                  if (index >= 0) {
                    return index % 2 === 0 ? 0 : 30
                  }
                  return 0
                }}
              />
            }
            style={{
              data: { stroke: '#7BAD2D', strokeWidth: '2px' },
              labels: {
                fill: 'rgba(123, 173, 45, 1)',
                fontSize: 11,
                fontFamily: 'Gliroy'
              }
            }}
          />
          <VictoryScatter
            dataComponent={<Scatter color={'rgba(123, 173, 45, 1)'} />}
            data={data}
            labelComponent={
              <VictoryTooltip
                // active={true}
                labelComponent={<HoverComp />}
                flyoutHeight={70}
                flyoutWidth={30}
                flyoutStyle={{
                  stroke: 'transparent',
                  strokeWidth: 2,
                  fill: 'white'
                }}
              />
            }
            labels={(datum) => {
              return datum.text
            }}
            style={{
              labels: {
                fontSize: 11,
                fill: 'rgba(123, 173, 45, 1)',
                fontFamily: 'Gliroy'
              }
            }}
          />
        </VictoryChart>
        <svg style={{ height: 0 }}>
          <defs>
            <linearGradient id="linear" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" stopColor="rgba(123, 173, 45, 0.5)" />
              <stop offset="100%" stopColor="rgba(123, 173, 45, 0)" />
            </linearGradient>
          </defs>
        </svg>
      </>
    )
  }

  function calculatePoints(originDatas) {
    let filteredData = _.filter(originDatas, (d) => d.value)
    if (from) {
      filteredData = filteredData.slice(-7)
    }
    const allWeight = filteredData.map((d) => d.value)
    let yTickValues
    let step = 1
    if (allWeight.length === 0) {
      yTickValues = [152, 151, 150, 149].reverse()
    } else if (allWeight.length === 1) {
      let max = Math.ceil(allWeight[0]) + 1
      yTickValues = [max, max - 1, max - 2, max - 3].reverse()
    } else {
      let max = Math.ceil(Math.max(...allWeight))
      let min = Math.floor(Math.min(...allWeight))

      while ((max - min) % 3 !== 0) {
        max += 1
        min -= 1
      }

      step = (max - min) / 3
      yTickValues = [
        max,
        max - 1 * step,
        max - 2 * step,
        max - 3 * step
      ].reverse()
    }
    return {
      yTickValues,
      step,
      data: filteredData.map((d, index) => {
        let percent = 0
        if (index > 0) {
          const previousValue = filteredData[index - 1].value
          if (previousValue === 0) {
            percent = 100
          } else {
            percent = ((d.value - previousValue) / previousValue) * 100
            percent = percent.toFixed(0)
          }
        } else {
          return {
            x: d.date,
            y: d.value - yTickValues[0],
            text: round(d.value, 1),
            source: d.source
          }
        }
        return {
          x: d.date,
          y: d.value - yTickValues[0],
          text: round(d.value, 1),
          source: d.source,
          percent
        }
      })
    }
  }

  function HoverComp(props) {
    const {
      x,
      y,
      datum: { text, source, percent }
    } = props

    const sourceStr = ConvertWeightSource(source)
    const textWidth = calcTextWidth(sourceStr, { size: 12.5 })

    let overWidth = x - 80 + (textWidth < 150 ? 150 : textWidth) + 20 - width
    if (overWidth < 0) {
      overWidth = 0
    }

    return (
      <g>
        <foreignObject
          x={x - 80 - overWidth}
          y={y - 11.6 - 35}
          height={84}
          width={(textWidth < 150 ? 150 : textWidth) + 60}
        >
          <BiomeWeightHoverContainer>
            <div className="weight-source-data">
              <span>Weight</span>
              {ConvertSourceToComp(source)}
            </div>
            <div className="weight-data-container">
              <div>
                <span className="dot" />
                <span className="date">
                  {moment(props.datum.x, 'YYYY-MM-DD').format('MM/DD/YYYY')}
                </span>
              </div>
              <div>
                <span>{text}</span>
                {percent && (
                  <span className="changes">
                    {percent > 0 ? (
                      <ArrowUpOutlined
                        style={{
                          fontSize: 12,
                          color: '#9aa5b1'
                        }}
                      />
                    ) : (
                      <ArrowDownOutlined
                        style={{
                          fontSize: 12,
                          color: '#9aa5b1'
                        }}
                      />
                    )}
                    {Math.abs(percent)}%
                  </span>
                )}
              </div>
            </div>
          </BiomeWeightHoverContainer>
        </foreignObject>
      </g>
    )
  }
}

function Scatter(props) {
  return (
    <svg
      width="12"
      height="12"
      x={props.x - 6}
      y={props.y - 6}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props.events}
    >
      <circle
        cx="6"
        cy="6"
        r="4"
        fill="white"
        stroke={props.color}
        strokeWidth="2"
      />
    </svg>
  )
}

const SourceContainer = styled.div`
  display: flex;
  align-items: center;
  * {
    margin-left: 4px;
  }
`

const ManualTag = styled.span`
  border-radius: 4px;
  font-size: 12px;
  color: #8596a4;
  background-color: #f1f3f6;
  padding: 2px 7px;
`

const ImgTag = styled.img`
  height: 24px;
`

export function ConvertSourceToComp(source) {
  if (!source) {
    return (
      <SourceContainer>
        <ManualTag>Manual</ManualTag>
      </SourceContainer>
    )
  }
  return (
    <SourceContainer>
      {uniq(source.split(', ')).map((item, index) => {
        switch (item.toLocaleLowerCase()) {
          case 'garmin':
            return <ImgTag src={garminIcon} alt="garmin" key={index} />
          case 'ouraring':
            return <ImgTag src={ouraIcon} alt="ouraring" key={index} />
          case 'healthkit':
            return <ImgTag src={healthkitIcon} alt="healthkit" key={index} />
          case 'polar':
            return <ImgTag src={PolarIcon} alt="polar" key={index} />
          case 'withings':
            return <ImgTag src={WithingsIcon} alt="withings" key={index} />
          case 'apeiron scale':
          case 'dataset':
            return (
              <ImgTag src={ApeironScaleIcon} alt="apeiron scale" key={index} />
            )
          default:
            return <ManualTag key={index}>Manual</ManualTag>
        }
      })}
    </SourceContainer>
  )
}
